import { render, staticRenderFns } from "./giftcards-to-me.vue?vue&type=template&id=3f09a2f4&scoped=true&lang=html&"
import script from "./giftcards-to-me.vue?vue&type=script&lang=js&"
export * from "./giftcards-to-me.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f09a2f4",
  null
  
)

export default component.exports